/* ==========================================================================
   BodenWerk – Videoqualität nach Gerät

   Shopify legt zu jedem hochgeladenen Video mehrere Renditions an. Das Theme
   verwies überall auf HD-720p mit 4,5 Mbit. Auf der Startseite waren das rund
   11,5 MB, auf dem Handy dieselben Dateien wie am Schreibtisch.

   Die SD-Rendition hat 1,5 Mbit bei 852 px Breite. Das genügt einem 390-px-
   Display auch bei doppelter Pixeldichte. Ist der Datensparmodus aktiv, läuft
   gar kein Video und das Poster bleibt stehen.

   Betrifft jedes <video> mit data-src-hd. Im Markup steht bewusst kein src,
   sonst lädt der Browser die HD-Datei, bevor dieses Skript wählen kann.

   Öffentlich: window.bwVideoQualitaet = 'aus' | 'sd' | 'hd'
   ========================================================================== */
(function () {
  'use strict';

  var QUALITAET = (function () {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (c && c.saveData) return 'aus';
    } catch (e) {}
    return window.matchMedia('(max-width: 900px)').matches ? 'sd' : 'hd';
  })();

  window.bwVideoQualitaet = QUALITAET;

  function bespielen(v) {
    if (!v || v.__bwQuelleGesetzt) return;
    v.__bwQuelleGesetzt = true;
    if (QUALITAET === 'aus') return; // Poster trägt die Fläche

    var sd = v.getAttribute('data-src-sd');
    var hd = v.getAttribute('data-src-hd');
    var url = QUALITAET === 'sd' && sd ? sd : hd;
    if (!url) return;

    v.src = url;
    v.load();
    if (v.hasAttribute('data-bw-autostart')) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  // Videos unterhalb des Sichtfelds erst laden, wenn sie in die Nähe kommen.
  // Der Editorial-Loop hing sonst am ersten Seitenaufbau, obwohl ihn niemand
  // sieht. 300 px Vorlauf, damit er beim Hinscrollen schon läuft.
  var beobachter = null;
  if (window.IntersectionObserver) {
    beobachter = new IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].isIntersecting) {
          beobachter.unobserve(eintraege[i].target);
          bespielen(eintraege[i].target);
        }
      }
    }, { rootMargin: '300px 0px' });
  }

  function imSichtfeld(v) {
    var r = v.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function initAll() {
    var knoten = document.querySelectorAll('video[data-src-hd]');
    for (var i = 0; i < knoten.length; i++) {
      var v = knoten[i];
      if (v.__bwQuelleGesetzt || v.__bwBeobachtet) continue;
      if (!beobachter || imSichtfeld(v)) {
        bespielen(v);
      } else {
        v.__bwBeobachtet = true;
        beobachter.observe(v);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
